import styled from "@emotion/styled";
import { Button } from "@mui/material";

export const DialogBtn = styled(Button)`
  padding: 10px 16px;
  border-radius: 16px;
  font-size: 16px;
  margin: 8px;
`;
